<template>
    <popup :opened="dataToShow" @close="close">
        <!-- BEGIN Content modal add Besoin -->
        <div v-if="dataToShow">
            <div class="my-5 mx-5 lg:my-15 lg:mx-10 2xl:my-20 2xl:mx-15">
                <h3 class="mb-10">Ajouter un besoin manuellement</h3>
                <h6 class="text-indigo-600">Saissisez le nom du besoin à ajouter.</h6>
                <h6 class="text-indigo-600 mb-8">Vous pouvez en ajouter plusieurs à la fois en les séparant d’une virgule.</h6>
                <div class="flex justify-center">
                    <input-text
                        :error="true"
                        placeholder="Exemple : “D'être rassuré“"
                        :value="needName"
                        class="lg:w-1/2"
                        libelle="Besoin"
                        name="needName"
                        @input="(newValue) => {needName = newValue}"
                        :maxlength="limit"
                    />
                </div>

                <div class="flex justify-center mt-15">
                    <action-button
                        border-color="border-transparent"
                        text-color="text-white"
                        bg-color="bg-pink-600"
                        bg-color-square="bg-pink-600"
                        icon-color="text-white"
                        libelle="AJOUTER"
                        type-shadow="shadow-pink"
                        @clickAction="addNeed()"
                    />
                </div>

            </div>
        </div>
    </popup>
</template>

<script>
import Popup from '../../../components/Popup.vue';
import Icon from  '../../../components/Icon.vue';
import InputText from '../../../components/Inputs/InputText.vue';
import InputSelect from '../../../components/Inputs/InputSelect.vue';
import DatePicker from '../../../components/Inputs/DatePicker.vue';
import ActionButton from '../../../components/ActionButton.vue';

export default {
  name:'PopupNewNeed',

  components:{
    Popup,
    Icon,
    InputText,
    InputSelect,
    DatePicker,
    ActionButton,
  },

  props:{
    dataToShow:{
      type: Boolean,
      required: false,
      default: false
    },
    limit:{
      type:Number,
      required:false,
      default: null
    }
  },

  data(){
    return {
      needName: '',
    };
  },

  methods:{
    close(){
      this.$emit('close');
      this.needName = '';
    },

    addNeed(){
      this.$emit('addNeed', this.needName);
      this.close(false);
      this.needName = '';
    },
  },
  watch:{
    //
  }
};
</script>
